var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.overlay)?_c('div',{staticClass:"dtt-loader-overlay"},[_c('div',{class:['dtt-loader', _vm.size]})]):_c('div',{class:['dtt-loader', _vm.size]})])
}
var staticRenderFns = []

export { render, staticRenderFns }